export const en = {
  'shell.nav.knowledge': 'Knowledge base',
  'enum.kbStatus.DRAFT': 'Draft',
  'enum.kbStatus.PUBLISHED': 'Published',

  'kb.title': 'Knowledge base',
  'kb.description': 'How the gym runs: procedures, policies and rules, shown to the roles each one is for.',
  'kb.new': 'New article',
  'kb.searchPlaceholder': 'Search titles and text',
  'kb.allArticles': 'All articles',
  'kb.categoriesLabel': 'Categories',
  'kb.anyStatus': 'Published and drafts',
  'kb.sort': 'Order',
  'kb.sort.recent': 'Recently updated',
  'kb.sort.title': 'Title',
  'kb.clearFilters': 'Clear filters',
  'kb.awaiting.one': 'One required article is waiting for you to confirm you have read it.',
  'kb.awaiting.other': '{count} required articles are waiting for you to confirm you have read them.',
  'kb.awaitingShow': 'Show',
  'kb.awaitingHide': 'Show everything',
  'kb.empty': 'No articles yet',
  'kb.emptyManager': 'Write the gym’s first procedure and choose who it is for.',
  'kb.emptyStaff': 'Nothing has been published for your role yet.',
  'kb.noMatch': 'No articles match',
  'kb.noMatchHint': 'Try other words or clear the filters.',
  'kb.mustRead': 'Required reading',
  'kb.toConfirm': 'Please confirm',
  'kb.read': 'Read',
  'kb.unpublishedChanges': 'Unpublished changes',
  'kb.audience.all': 'All staff',
  'kb.updated': 'Updated {date}',
  'kb.updatedBy': 'Updated {date} · {name}',
  'kb.version': 'Version {version}',

  'kb.draftNotice': 'This article is a draft. Only editors can see it.',
  'kb.changesNotice': 'This article has changes that staff cannot see until you publish them.',
  'kb.otherLanguage': 'Not written in this language yet. Showing the {shown} text.',
  'kb.language.en': 'English',
  'kb.language.ka': 'Georgian',
  'kb.confirm.title': 'Required reading',
  'kb.confirm.ask': 'You are asked to confirm you have read this article. If it is changed and published again, you will be asked again.',
  'kb.confirm.button': 'I have read this',
  'kb.confirm.done': 'You confirmed reading version {version} on {date}.',
  'kb.confirm.thanks': 'Confirmed. Thank you.',
  'kb.tab.article': 'Article',
  'kb.tab.readers': 'Who has read it',
  'kb.tab.revisions': 'Revisions',

  'kb.readers.summary': '{confirmed} of {required} have confirmed version {version}.',
  'kb.readers.notRequired': 'This article is not marked as required reading, so nobody is asked to confirm it.',
  'kb.readers.notPublished': 'Nobody can confirm the article until it is published.',
  'kb.readers.nobody': 'No staff member holds a role this article is for.',
  'kb.readers.person': 'Person',
  'kb.readers.role': 'Role',
  'kb.readers.status': 'Status',
  'kb.readers.confirmed': 'Confirmed {date}',
  'kb.readers.waiting': 'Waiting',
  'kb.readers.earlier': 'Read version {version}',
  'kb.readers.never': 'Has not read it',

  'kb.revisions.empty': 'Nothing has been published yet.',
  'kb.revisions.published': 'Published {date} · {name}',
  'kb.revisions.current': 'Current',
  'kb.revisions.show': 'Show text',
  'kb.revisions.restore': 'Restore to draft',
  'kb.revisions.restored': 'Version {version} copied into the draft. Publish it to share it.',

  'kb.editor.new': 'New article',
  'kb.editor.edit': 'Edit article',
  'kb.editor.titleLabel': 'Title',
  'kb.editor.bodyLabel': 'Text',
  'kb.editor.bodyHint': 'Markdown: ## for headings, - for lists, **bold** for emphasis.',
  'kb.editor.titleRequired': 'Give the title in at least one language',
  'kb.editor.content': 'Content',
  'kb.editor.settings': 'Settings',
  'kb.editor.category': 'Category',
  'kb.editor.noCategory': 'No category',
  'kb.editor.audience': 'Who sees it',
  'kb.editor.audienceHint': 'Leave every role unticked to show the article to all staff. Owners, admins and gym general managers always see every article.',
  'kb.editor.mustRead': 'Required reading',
  'kb.editor.mustReadHint': 'Ask the staff it is for to confirm they have read it. Publishing a new version asks them again.',
  'kb.editor.liveNote': 'Category, audience and required reading apply as soon as you save. The title and text stay a draft until you publish.',
  'kb.editor.unsaved': 'Unsaved changes',
  'kb.saveDraft': 'Save',
  'kb.saved': 'Saved',
  'kb.created': 'Article created',
  'kb.publish': 'Publish',
  'kb.publishVersion': 'Publish version {version}',
  'kb.publishTitle': 'Publish this article?',
  'kb.publishDescription': 'The staff it is for will see this text straight away.',
  'kb.publishDescriptionMustRead': 'The staff it is for will see this text straight away and be asked to confirm they have read it, including those who confirmed an earlier version.',
  'kb.published': 'Published version {version}',
  'kb.hint.saveFirst': 'Save your changes before publishing.',
  'kb.hint.upToDate': 'Staff see the latest text.',
  'kb.hint.draft': 'Staff cannot see this article until it is published.',
  'kb.unpublish': 'Unpublish',
  'kb.unpublishTitle': 'Unpublish this article?',
  'kb.unpublishDescription': 'Staff will no longer see it. The revisions are kept and you can publish it again.',
  'kb.unpublished': 'Unpublished',
  'kb.delete': 'Delete',
  'kb.deleteTitle': 'Delete this article?',
  'kb.deleteDescription': 'The article, its revisions and the read confirmations are deleted. This cannot be undone.',
  'kb.deleted': 'Article deleted',

  'kb.categories.title': 'Categories',
  'kb.categories.description': 'Group the articles so staff can find them.',
  'kb.categories.add': 'Add category',
  'kb.categories.name': 'Name',
  'kb.categories.order': 'Order',
  'kb.categories.none': 'No categories yet.',
  'kb.categories.saved': 'Category saved',
  'kb.categories.deleted': 'Category deleted',
  'kb.categories.deleteTitle': 'Delete this category?',
  'kb.categories.deleteDescription': 'Only an empty category can be deleted.',
  'kb.categories.articles': '{count} articles',

  'kb.pictures.title': 'Pictures',
  'kb.pictures.hint': 'Pictures are private: only staff who can read this article see them. A new picture goes at the end of the text; move its line to where it belongs.',
  'kb.pictures.saveFirst': 'Save the article once to add pictures.',
  'kb.pictures.add': 'Add a picture',
  'kb.pictures.added': 'Picture added to the text',
  'kb.pictures.empty': 'No pictures yet. JPEG, PNG or WebP, up to 10 MB.',
  'kb.pictures.insert': 'Insert',
  'kb.pictures.remove': 'Remove {name}',
  'kb.pictures.removed': 'Picture removed',
  'kb.pictures.removeTitle': 'Remove this picture?',
  'kb.pictures.removeDescription': 'It is deleted for good and taken out of the draft. Older versions that showed it show only its caption.',
  'kb.pictures.describe': 'Caption and description of {name}',
  'kb.pictures.describeTitle': 'Caption and description',
  'kb.pictures.describeDescription': 'Readers see the caption under the picture, and screen readers read the description in place of the picture. A change shows to readers at once, without publishing the article again.',
  'kb.pictures.caption': 'Caption',
  'kb.pictures.captionHint': 'Shown under the picture. Leave empty for none.',
  'kb.pictures.altText': 'Description for screen readers',
  'kb.pictures.altTextHint': 'What the picture shows, in one short sentence.',
  'kb.pictures.tooLong': 'At most {max} characters in each language',
  'kb.pictures.described': 'Caption and description saved',
  'kb.settings.title': 'Reminders',
  'kb.settings.description': 'Staff who have not confirmed a required article get a reminder in the app, once for each published version.',
  'kb.settings.remind': 'Remind staff of required reading',
  'kb.settings.remindHint': 'Only the people the article is for who have not confirmed it yet.',
  'kb.settings.days': 'Days after publishing',
  'kb.settings.daysHint': 'From 1 to 30 days.',
  'kb.settings.daysInvalid': 'Enter a whole number from 1 to 30.',
  'kb.settings.saved': 'Reminder settings saved',

  'admin.apiError.KB_ARTICLE_EMPTY': 'Write a title and some text before publishing.',
  'admin.apiError.KB_NOTHING_TO_PUBLISH': 'There are no changes to publish.',
  'admin.apiError.KB_CATEGORY_NOT_EMPTY': 'Move or delete the articles in this category first.',
  'admin.apiError.KB_CONFIRMATION_NOT_REQUIRED': 'This article does not ask you to confirm it.',
  'admin.apiError.KB_TOO_MANY_IMAGES': 'An article holds at most 50 pictures. Remove one first.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.knowledge': 'ცოდნის ბაზა',
  'enum.kbStatus.DRAFT': 'მონახაზი',
  'enum.kbStatus.PUBLISHED': 'გამოქვეყნებული',

  'kb.title': 'ცოდნის ბაზა',
  'kb.description': 'როგორ მუშაობს დარბაზი: პროცედურები, პოლიტიკა და წესები, რომლებიც ჩანს იმ როლებისთვის, ვისთვისაც არის განკუთვნილი.',
  'kb.new': 'ახალი სტატია',
  'kb.searchPlaceholder': 'მოძებნეთ სათაურსა და ტექსტში',
  'kb.allArticles': 'ყველა სტატია',
  'kb.categoriesLabel': 'კატეგორიები',
  'kb.anyStatus': 'გამოქვეყნებული და მონახაზები',
  'kb.sort': 'რიგითობა',
  'kb.sort.recent': 'ბოლოს განახლებული',
  'kb.sort.title': 'სათაური',
  'kb.clearFilters': 'ფილტრების გასუფთავება',
  'kb.awaiting.one': 'ერთი სავალდებულო სტატია ელოდება თქვენს დადასტურებას, რომ წაიკითხეთ.',
  'kb.awaiting.other': '{count} სავალდებულო სტატია ელოდება თქვენს დადასტურებას, რომ წაიკითხეთ.',
  'kb.awaitingShow': 'ჩვენება',
  'kb.awaitingHide': 'ყველას ჩვენება',
  'kb.empty': 'სტატიები ჯერ არ არის',
  'kb.emptyManager': 'დაწერეთ დარბაზის პირველი პროცედურა და აირჩიეთ, ვისთვისაა.',
  'kb.emptyStaff': 'თქვენი როლისთვის ჯერ არაფერი გამოქვეყნებულა.',
  'kb.noMatch': 'სტატიები ვერ მოიძებნა',
  'kb.noMatchHint': 'სცადეთ სხვა სიტყვები ან გაასუფთავეთ ფილტრები.',
  'kb.mustRead': 'სავალდებულო საკითხავი',
  'kb.toConfirm': 'დაადასტურეთ',
  'kb.read': 'წაკითხულია',
  'kb.unpublishedChanges': 'გამოუქვეყნებელი ცვლილებები',
  'kb.audience.all': 'მთელი პერსონალი',
  'kb.updated': 'განახლდა {date}',
  'kb.updatedBy': 'განახლდა {date} · {name}',
  'kb.version': 'ვერსია {version}',

  'kb.draftNotice': 'ეს სტატია მონახაზია. მას მხოლოდ რედაქტორები ხედავენ.',
  'kb.changesNotice': 'სტატიაში არის ცვლილებები, რომლებსაც პერსონალი ვერ ხედავს, სანამ არ გამოაქვეყნებთ.',
  'kb.otherLanguage': 'ამ ენაზე ტექსტი ჯერ არ არის დაწერილი. ნაჩვენებია {shown} ტექსტი.',
  'kb.language.en': 'ინგლისური',
  'kb.language.ka': 'ქართული',
  'kb.confirm.title': 'სავალდებულო საკითხავი',
  'kb.confirm.ask': 'გთხოვთ, დაადასტუროთ, რომ ეს სტატია წაიკითხეთ. თუ ის შეიცვლება და ხელახლა გამოქვეყნდება, დადასტურება კვლავ დაგჭირდებათ.',
  'kb.confirm.button': 'წავიკითხე',
  'kb.confirm.done': 'თქვენ დაადასტურეთ მე-{version} ვერსიის წაკითხვა {date}.',
  'kb.confirm.thanks': 'დადასტურებულია. გმადლობთ.',
  'kb.tab.article': 'სტატია',
  'kb.tab.readers': 'ვინ წაიკითხა',
  'kb.tab.revisions': 'რევიზიები',

  'kb.readers.summary': '{required}-დან {confirmed}-მა დაადასტურა ვერსია {version}.',
  'kb.readers.notRequired': 'ეს სტატია არ არის მონიშნული სავალდებულო საკითხავად, ამიტომ არავის სთხოვენ დადასტურებას.',
  'kb.readers.notPublished': 'სანამ სტატია არ გამოქვეყნდება, დადასტურებას ვერავინ შეძლებს.',
  'kb.readers.nobody': 'არცერთ თანამშრომელს არ აქვს როლი, რომლისთვისაც ეს სტატიაა განკუთვნილი.',
  'kb.readers.person': 'თანამშრომელი',
  'kb.readers.role': 'როლი',
  'kb.readers.status': 'სტატუსი',
  'kb.readers.confirmed': 'დაადასტურა {date}',
  'kb.readers.waiting': 'ელოდება',
  'kb.readers.earlier': 'წაკითხული აქვს ვერსია {version}',
  'kb.readers.never': 'არ წაუკითხავს',

  'kb.revisions.empty': 'ჯერ არაფერი გამოქვეყნებულა.',
  'kb.revisions.published': 'გამოქვეყნდა {date} · {name}',
  'kb.revisions.current': 'მიმდინარე',
  'kb.revisions.show': 'ტექსტის ჩვენება',
  'kb.revisions.restore': 'მონახაზში დაბრუნება',
  'kb.revisions.restored': 'ვერსია {version} გადაკოპირდა მონახაზში. გასაზიარებლად გამოაქვეყნეთ.',

  'kb.editor.new': 'ახალი სტატია',
  'kb.editor.edit': 'სტატიის რედაქტირება',
  'kb.editor.titleLabel': 'სათაური',
  'kb.editor.bodyLabel': 'ტექსტი',
  'kb.editor.bodyHint': 'Markdown: ## სათაურებისთვის, - სიებისთვის, **მუქი** ხაზგასასმელად.',
  'kb.editor.titleRequired': 'მიუთითეთ სათაური მინიმუმ ერთ ენაზე',
  'kb.editor.content': 'შინაარსი',
  'kb.editor.settings': 'პარამეტრები',
  'kb.editor.category': 'კატეგორია',
  'kb.editor.noCategory': 'კატეგორიის გარეშე',
  'kb.editor.audience': 'ვის ეჩვენება',
  'kb.editor.audienceHint': 'თუ არცერთ როლს არ მონიშნავთ, სტატია მთელ პერსონალს გამოეჩინება. მფლობელები, ადმინისტრატორები და დარბაზის გენერალური მენეჯერები ყველა სტატიას ყოველთვის ხედავენ.',
  'kb.editor.mustRead': 'სავალდებულო საკითხავი',
  'kb.editor.mustReadHint': 'სთხოვეთ პერსონალს, ვისთვისაც სტატიაა განკუთვნილი, დაადასტუროს წაკითხვა. ახალი ვერსიის გამოქვეყნებისას დადასტურებას კვლავ მოსთხოვთ.',
  'kb.editor.liveNote': 'კატეგორია, აუდიტორია და სავალდებულო საკითხავი ძალაში შედის შენახვისთანავე. სათაური და ტექსტი მონახაზად რჩება გამოქვეყნებამდე.',
  'kb.editor.unsaved': 'შეუნახავი ცვლილებები',
  'kb.saveDraft': 'შენახვა',
  'kb.saved': 'შენახულია',
  'kb.created': 'სტატია შეიქმნა',
  'kb.publish': 'გამოქვეყნება',
  'kb.publishVersion': 'ვერსია {version}-ის გამოქვეყნება',
  'kb.publishTitle': 'გამოვაქვეყნოთ სტატია?',
  'kb.publishDescription': 'პერსონალი, ვისთვისაც სტატიაა განკუთვნილი, ამ ტექსტს მაშინვე დაინახავს.',
  'kb.publishDescriptionMustRead': 'პერსონალი, ვისთვისაც სტატიაა განკუთვნილი, ამ ტექსტს მაშინვე დაინახავს და მოეთხოვება წაკითხვის დადასტურება, იმათაც, ვინც წინა ვერსია დაადასტურა.',
  'kb.published': 'გამოქვეყნდა ვერსია {version}',
  'kb.hint.saveFirst': 'გამოქვეყნებამდე შეინახეთ ცვლილებები.',
  'kb.hint.upToDate': 'პერსონალი უახლეს ტექსტს ხედავს.',
  'kb.hint.draft': 'სანამ სტატია არ გამოქვეყნდება, პერსონალი მას ვერ ხედავს.',
  'kb.unpublish': 'გამოქვეყნების გაუქმება',
  'kb.unpublishTitle': 'გავაუქმოთ სტატიის გამოქვეყნება?',
  'kb.unpublishDescription': 'პერსონალი მას აღარ დაინახავს. რევიზიები ინახება და სტატიის ხელახლა გამოქვეყნება შეგიძლიათ.',
  'kb.unpublished': 'გამოქვეყნება გაუქმებულია',
  'kb.delete': 'წაშლა',
  'kb.deleteTitle': 'წავშალოთ სტატია?',
  'kb.deleteDescription': 'სტატია, მისი რევიზიები და წაკითხვის დადასტურებები წაიშლება. ამის გაუქმება შეუძლებელია.',
  'kb.deleted': 'სტატია წაიშალა',

  'kb.categories.title': 'კატეგორიები',
  'kb.categories.description': 'დააჯგუფეთ სტატიები, რომ პერსონალმა ადვილად იპოვოს.',
  'kb.categories.add': 'კატეგორიის დამატება',
  'kb.categories.name': 'სახელი',
  'kb.categories.order': 'რიგითობა',
  'kb.categories.none': 'კატეგორიები ჯერ არ არის.',
  'kb.categories.saved': 'კატეგორია შეინახა',
  'kb.categories.deleted': 'კატეგორია წაიშალა',
  'kb.categories.deleteTitle': 'წავშალოთ კატეგორია?',
  'kb.categories.deleteDescription': 'წაიშლება მხოლოდ ცარიელი კატეგორია.',
  'kb.categories.articles': '{count} სტატია',

  'admin.apiError.KB_ARTICLE_EMPTY': 'გამოქვეყნებამდე დაწერეთ სათაური და ტექსტი.',
  'admin.apiError.KB_NOTHING_TO_PUBLISH': 'გამოსაქვეყნებელი ცვლილებები არ არის.',
  'admin.apiError.KB_CATEGORY_NOT_EMPTY': 'ჯერ გადაიტანეთ ან წაშალეთ ამ კატეგორიის სტატიები.',
  'admin.apiError.KB_CONFIRMATION_NOT_REQUIRED': 'ამ სტატიისთვის დადასტურება არ მოითხოვება.',
  'admin.apiError.KB_TOO_MANY_IMAGES': 'სტატიაში მაქსიმუმ 50 სურათია დასაშვები. ჯერ ერთი წაშალეთ.',
  'kb.pictures.title': 'სურათები',
  'kb.pictures.hint': 'სურათები პირადია: მათ ხედავს მხოლოდ ის პერსონალი, ვისაც ამ სტატიის წაკითხვა შეუძლია. ახალი სურათი ტექსტის ბოლოს ემატება; გადაიტანეთ მისი ხაზი სასურველ ადგილას.',
  'kb.pictures.saveFirst': 'სურათების დასამატებლად ჯერ შეინახეთ სტატია.',
  'kb.pictures.add': 'სურათის დამატება',
  'kb.pictures.added': 'სურათი ტექსტს დაემატა',
  'kb.pictures.empty': 'სურათები ჯერ არ არის. JPEG, PNG ან WebP, 10 მბ-მდე.',
  'kb.pictures.insert': 'ჩასმა',
  'kb.pictures.remove': '{name} — წაშლა',
  'kb.pictures.removed': 'სურათი წაიშალა',
  'kb.pictures.removeTitle': 'წავშალოთ ეს სურათი?',
  'kb.pictures.removeDescription': 'სურათი სამუდამოდ წაიშლება და მონახაზიდან ამოიღება. ძველ ვერსიებში მის ადგილას მხოლოდ წარწერა გამოჩნდება.',
  'kb.pictures.describe': '{name} — წარწერა და აღწერა',
  'kb.pictures.describeTitle': 'წარწერა და აღწერა',
  'kb.pictures.describeDescription': 'მკითხველი წარწერას სურათის ქვეშ ხედავს, ეკრანის წამკითხველი კი სურათის ნაცვლად აღწერას კითხულობს. ცვლილება მკითხველს მაშინვე ეჩვენება, სტატიის თავიდან გამოქვეყნება საჭირო არ არის.',
  'kb.pictures.caption': 'წარწერა',
  'kb.pictures.captionHint': 'ჩანს სურათის ქვეშ. თუ არ გინდათ, დატოვეთ ცარიელი.',
  'kb.pictures.altText': 'აღწერა ეკრანის წამკითხველისთვის',
  'kb.pictures.altTextHint': 'ერთი მოკლე წინადადებით — რას აჩვენებს სურათი.',
  'kb.pictures.tooLong': 'თითოეულ ენაზე მაქსიმუმ {max} სიმბოლო',
  'kb.pictures.described': 'წარწერა და აღწერა შენახულია',
  'kb.settings.title': 'შეხსენებები',
  'kb.settings.description': 'პერსონალი, ვისაც სავალდებულო სტატია არ დაუდასტურებია, აპლიკაციაში შეხსენებას მიიღებს, თითოეულ გამოქვეყნებულ ვერსიაზე ერთხელ.',
  'kb.settings.remind': 'სავალდებულო საკითხავის შეხსენება',
  'kb.settings.remindHint': 'მხოლოდ მათ, ვისთვისაც სტატიაა განკუთვნილი და ჯერ არ დაუდასტურებიათ.',
  'kb.settings.days': 'დღეები გამოქვეყნების შემდეგ',
  'kb.settings.daysHint': '1-დან 30 დღემდე.',
  'kb.settings.daysInvalid': 'შეიყვანეთ მთელი რიცხვი 1-დან 30-მდე.',
  'kb.settings.saved': 'შეხსენების პარამეტრები შენახულია',
};
